import { DatePipe, SlicePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';

@Pipe({
    name: 'simpleDateTime'
})
export class SimpleDateTimePipe implements PipeTransform {
    //   transform(value: unknown, ...args: unknown[]): unknown {
    //     return null;
    //   }
    transform(value: string | Date | Moment, arg?: string): any {
        let val: string = String(value);
        let slicedValue: string;

        arg = arg ? arg : 'MM/dd/yyyy h:mm:ss a';

        if (val.substring(0, 1) === '/D' || val.substring(0, 1) === '/d') {
            slicedValue = new SlicePipe().transform(val, 6, -2);
            return new DatePipe('en-US').transform(new Date(parseInt(slicedValue)), arg);
        } else if (!moment(val).isValid()) {
            return '';
        } else {
            slicedValue = val;
            return new DatePipe('en-US').transform(new Date(slicedValue), arg);
        }
    }
}
